import React from "react";
import "./styles/CallToAction.css";
import Tada from "react-reveal/Tada";
import { Link } from "react-router-dom";
import FormButton from "./ui/FormButton";
const CallToAction = ({ condicionales, setCondicionales }) => {
  return (
    <>
      <div className="c-calltoaction">
        <h3 className="cta-message">Me encantaría saber sobre tus proyectos</h3>
        <div className="cta-button">
          <FormButton to={'/contact'} type="button">Vamos a charlar </FormButton>
        </div>
      </div>
    </>
  );
};

export default CallToAction;
